const _env = (key: string): string =>
  (window as typeof window & { _env_?: Record<string, string> })._env_?.[key]
  ?? process.env[key]
  ?? '';

const isLoopbackHost = (hostname: string): boolean => (
  ['localhost', '127.0.0.1', '0.0.0.0', '::1', '[::1]'].includes(hostname)
);

const normalizeBaseUrl = (raw: string): string => {
  const value = raw.trim().replace(/\/+$/, '');
  if (!value) return '';
  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
};

export const getTenantVanityFromHost = (): string => {
  const hostname = window.location.hostname.toLowerCase();
  const baseDomain = _env('REACT_APP_BASE_DOMAIN').toLowerCase();
  const localDevVanity = _env('REACT_APP_LOCAL_DEV_VANITY').trim().toLowerCase();

  if (baseDomain && hostname.endsWith(`.${baseDomain}`)) {
    return hostname.slice(0, -(baseDomain.length + 1));
  }

  if (
    localDevVanity
    && /^[a-z0-9-]+$/.test(localDevVanity)
    && isLoopbackHost(hostname)
  ) {
    return localDevVanity;
  }

  const firstLabel = hostname.split('.')[0];
  return firstLabel && !firstLabel.includes('localhost') ? firstLabel : '';
};

export const getLoginAgainUrl = (): string => {
  const loginPortalUrl = _env('REACT_APP_LOGIN_URL');
  const apiBaseUrl = normalizeBaseUrl(_env('REACT_APP_API_BASE_URL'));
  const vanity = getTenantVanityFromHost();
  const localDevVanity = _env('REACT_APP_LOCAL_DEV_VANITY').trim().toLowerCase();

  if (
    apiBaseUrl
    && vanity
    && localDevVanity === vanity
    && isLoopbackHost(window.location.hostname.toLowerCase())
  ) {
    const params = new URLSearchParams({
      vanity,
      return_url: window.location.origin,
    });
    return `${apiBaseUrl}/api/v1/auth/login?${params.toString()}`;
  }

  if (loginPortalUrl && vanity) {
    const base = loginPortalUrl.replace(/\/+$/, '');
    return `${base}/${encodeURIComponent(vanity)}`;
  }

  return loginPortalUrl || '/';
};
